// 护理科研门诊 H5 · 基础配置
// apiUrl 现在是真正可配置的了，来自 .env.development / .env.pre-release / .env.production
// 这几个文件，Vue CLI 会根据打包命令(见下面注释)自动选用对应那份，不用改代码。
//   本地开发：npm run dev                          → 用 .env.development
//   预发布：  npm run build -- --mode pre-release   → 用 .env.pre-release
//   正式上线：npm run build                         → 用 .env.production
const apiUrl = process.env.VUE_APP_API_URL;

export default {
  apiUrl,
  apiPrefix: "",
  timeout: 60000,
  tokenKey: "NRC_H5_ACCESS_TOKEN",
  userInfoKey: "NRC_H5_USER_INFO",
  siteName: "护理科研门诊",
  requestRetry: 0,
  requestRetryDelay: 1000,
};
